import { BANNED_URLS, PAGE_TYPES } from '../constants/assistant-config';

export const getPortalRootNode = () => {
  return document?.querySelector('#root');
};

export const getStickyATCElement = () => {
  // Query elements matching the markup added by the Sticky component
  const buyboxMatch = document.querySelector(
    'div[data-component^=buybox\\:Buybox\\:v] [style^=min-height] > [class*=sticky]'
  );
  const applianceBuyboxMatch = document.querySelector(
    'div[data-component^=buybox\\:MajorApplianceBuyBox\\:v] [style^=min-height] > [class*=sticky]'
  );
  const buyboxActionsMatch = document.querySelector(
    'div[data-component^=buybox\\:BuyboxActions\\:v] [style^=min-height] > [class*=sticky]'
  );
  const buyboxSimpleMatch = document.querySelector(
    'div[data-component^=Buybox] [style^=min-height] > [class*=sticky]'
  );

  // Use the more specific section if available
  if (buyboxActionsMatch) return buyboxActionsMatch;

  if (applianceBuyboxMatch) return applianceBuyboxMatch;

  if (buyboxSimpleMatch) return buyboxSimpleMatch;

  // Use the generic (older) version as fallback
  if (buyboxMatch) return buyboxMatch;

  return null;
};

export const getPath = () => {
  return typeof window !== 'undefined' ? new URL(window.document.documentURI).pathname : '';
};

export const getPageType = () => {
  const pathArray = getPath()?.split('/') || [];

  if (pathArray[1] === 'c') return PAGE_TYPES.CONTENT;
  if (pathArray[1] === 'p') {
    if (pathArray[2] === 'sets') return PAGE_TYPES.BIP;
    return PAGE_TYPES.PIP;
  }
  if (pathArray[1] === 's') return PAGE_TYPES.SEARCH;
  if (pathArray[1] === 'b') return PAGE_TYPES.BROWSE;
  if (pathArray[1] === '') return PAGE_TYPES.HOME;

  return PAGE_TYPES.UNKNOWN;
};

export const isOneOfPageType = (pageTypes = []) => pageTypes.includes(getPageType());

export const isSessionExpired = (sessionTimestamp) => {
  // If no timestamp, consider it expired
  if (!sessionTimestamp) {
    return true;
  }

  const now = Date.now();
  const sessionAge = now - sessionTimestamp;

  // Session expires after 24 hours
  const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

  return sessionAge > TWENTY_FOUR_HOURS;
};

export const getSessionId = () => {
  const FALLBACK_SESSION_PREFIX = 'fallback-sessionId';

  if (typeof window !== 'undefined') {
    const cookieSessionId = window?.cookieUtils?.readBrowserCookie('thda.s');
    if (cookieSessionId) {
      return cookieSessionId;
    }
    const uuid = window?.crypto?.randomUUID?.() || Date.now();
    return `${FALLBACK_SESSION_PREFIX}-${uuid}`;
  }

  return `${FALLBACK_SESSION_PREFIX}-${Date.now()}`;
};

export const getDefaultSession = () => ({
  sessionId: getSessionId(),
  timestamp: Date.now(),
  shouldAutoOpen: false,
  hasSessionInteractedWithFab: false,
  pagesExpandedFABShownOn: [],
});

export const getIsCompatiblePage = () => {
  if (BANNED_URLS.includes(getPath())) {
    return false;
  }

  return [
    PAGE_TYPES.HOME,
    PAGE_TYPES.PIP,
    PAGE_TYPES.BROWSE,
    PAGE_TYPES.SEARCH,
    PAGE_TYPES.CONTENT,
  ].includes(getPageType());
};

export const waitForIdle = (callback, timeout = 3000) => {
  const run = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout });
    } else {
      // fallback for Safari/older browsers
      setTimeout(callback, 0);
    }
  };

  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run, { once: true });
  }
};
